module.exports = __webpack_public_path__ + "b-lite-1-before.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/b-lite-1-before.png
// module id = 1853
// module chunks = 0